<div class="fm-progress-bar--center">
  <invd-fm-progress-bar
    class="fm-progress-bar fm-progress-bar--medium"
    [steps]="steps"
    [currentStep]="currentStep"
  >
  </invd-fm-progress-bar>
</div>

<div class="available-rcr-takedowns-container container-fluid">
  <router-outlet></router-outlet>
</div>
